import React from 'react';
import eureka from 'eureka';
import { MicroFrontendProps, Entrypoint } from 'src/types';

const { useTranslation } = eureka.I18nProvider;

type Props = Pick<MicroFrontendProps, 'history' | 'config'>;

const Tiles: React.FC<Props> = (props) => {
  const { t } = useTranslation();

  const renderTiles = () => {
    const { config } = props;
    let entrypoints: Entrypoint[] | [] = [];
    if (config && config.components) {
      config.components.forEach((comp) => {
        if (comp.config.entrypoints) {
          entrypoints = [...entrypoints, ...comp.config.entrypoints];
        }
      });
    }
    const tiles = entrypoints.map((entry, idx) => (
      <div
        className="fd-panel icon-tile"
        key={idx.toString()}
        role="button"
        onClick={() => {
          if (entry.router) {
            props.history.push(entry.router);
          } else if (entry.url) {
            const newWin = window.open(
              entry.url,
              '_blank',
              'noopener,noreferrer,resizable,scrollbars',
            );
            if (newWin) {
              newWin.opener = null;
            }
          }
        }}
      >
        <div className="fd-panel__header">
          <div className="fd-panel__head">
            <h3 className="fd-panel__title">{t(entry.title)}</h3>
          </div>
        </div>
        <div className="fd-panel__body no-padding">
          <p className="tile-text">{t(entry.text)}</p>
          <span
            className={
              entry.icon
                ? `sap-icon ${entry.icon} sap-icon--xl`
                : `sap-icon sap-icon--chain-link sap-icon--xl`
            }
          />
        </div>
      </div>
    ));
    return <div className="fd-panel-grid fd-panel-grid--4col">{tiles}</div>;
  };

  return (
    <>
      <section className="fd-section" style={{ maxWidth: '1100px' }}>
        <div className="fd-section__header" style={{ minHeight: 0, marginTop: '24px' }} />
        {renderTiles()}
      </section>
    </>
  );
};

export default Tiles;
